import { Component, Vue } from 'vue-property-decorator'
import textInput from '../../../components/text-input/text-input.vue'
import { isGreaterThan, isBetween } from '../../../helper-functions/validators'
import addCertificate from '../add-google-certificate/add-google-certificate.vue'
import Multiselect from 'vue-multiselect'
import { IService, ICurrentService } from '@/types'

@Component({
  components: {
    textInput,
    addCertificate,
    Multiselect
  }
})

export default class AddDetails extends Vue {

  private namespace: string = '/Console';

  private clientEmailsAndIds: any = null;

  private incompleteServices: IService[] | null = null;

  private currentService: ICurrentService | null = null;

  private serpbookCatName: string = '';

  private analyticViewId: string = '';

  private analyticClientId: {label: string, clientId: string} | null = null;

  private addSerpBookOpen: boolean = false;

  private addAnalyticOpen: boolean = false;

  private addCertificateOpen: boolean = false;

  private alertMessage: string = '';

  private error: boolean = false;

  private get ClientCerificates (): {label: string, clientId: string}[] {

    return this.clientEmailsAndIds.map((client: {clientEmail: string, clientId: string}) => {

      return {label: client.clientEmail, clientId: client.clientId};
    });
  }

  private get SerpBookEnabled () {

    return isGreaterThan(0, this.serpbookCatName);
  }

  private get AnalyticEnabled () {

    return isBetween(5, 15, this.analyticViewId);
  }

  beforeMount () {

    this.getClientEmailsAndIds();
    this.getIncompleteServices();
  }

  private toggleCertificate () {

    this.addAnalyticOpen = !this.addAnalyticOpen;
    this.addCertificateOpen = !this.addAnalyticOpen;
  }

  private toggleInput (type: string, service?: IService) {

    if (service != undefined) {
  
      this.currentService = {
        serviceId: service.id,
        domain: service.domain
      } as ICurrentService;
    }

    if ('serpbook' === type) {
      
      return this.addSerpBookOpen = !this.addSerpBookOpen;
    }
    
    this.addAnalyticOpen = !this.addAnalyticOpen;
  }

  private alertReset () {

    setTimeout(() => {   

      if (this.error) {

        this.error = !this.error;
      }

      this.alertMessage = '';
    }, 5000);
  }

  private async saveSerpBook (type: string) {

    if (this.addSerpBookOpen) {

      this.addSerpBookOpen = !this.addSerpBookOpen;
    }

    try {

      const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/AddSerpBook`, {
        categoryName: this.serpbookCatName,
        ...this.currentService,
      });
      
      if (this.currentService) {
      
        this.alertMessage = `SerpBook successfully added to ${this.currentService.domain}`;
        this.serpbookCatName = '';
        this.currentService = null;
        this.alertReset();
      }
      
      this.getIncompleteServices();

    } catch (err) {

      this.error = !this.error;
      this.alertMessage = 'Ooops...';
      this.alertReset();
    }
  }

  private async saveGoogleAnalytic () {
    
    if (this.addAnalyticOpen) {

      this.addAnalyticOpen = !this.addAnalyticOpen;
    }

    try {

      const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/AddGoogleAnalytic`, {
        clientId: (this.analyticClientId as {label: string, clientId: string}).clientId,
        viewId: this.analyticViewId,
        ...this.currentService,
      });
      
      if (this.currentService) {

        this.alertMessage = `SerpBook successfully added to ${this.currentService.domain}`;
        this.analyticClientId = null;
        this.analyticViewId = '';
        this.alertReset();
      }

    } catch (err) {

      this.error = !this.error;
      this.alertMessage = 'Ooops...';
      this.alertReset();
    }
  }

  private async getIncompleteServices () {

    try {

      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/IncompleteServices`);

      this.incompleteServices = response.data;

    } catch (err) {

      console.error(err);
    }
  }

  private async getClientEmailsAndIds () {

    try {

      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/ClientCertificates`);

      this.clientEmailsAndIds = response.data;
    } catch (err) {

      console.error(err);
    }
  }
}